
import { Component } from 'vue-property-decorator'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import { Action, Getter } from 'vuex-class'
import OrderStatusesDto from '@/api/dto/OrderStatusesDto'
import ReturnStatusesDto from '@/api/dto/ReturnStatusesDto'
import SettingsMapping from '@/api/models/SettingsMapping'
import StorageMixin from '@/shared/mixins/StorageMixin.vue'

@Component({
    components: {
        BaseLayout
    },
    mixins: [StorageMixin]
})

export default class OrderStatuses extends BaseLayout {
    private readonly STATE = {
        DEFAULT: 'default',
        LOADING: 'loading'
    }

    @Getter('orderStatuses')
    orderStatuses!: Array<SettingsMapping>

    @Action('loadOrderStatusMapping')
    loadOrderStatusMapping!: () => Promise<void>

    @Action('saveOrderStatusMapping')
    saveOrderStatusMapping!: (mapping: OrderStatusesDto) => Promise<void>

    @Getter('returnOrderStatuses')
    returnOrderStatuses!: ReturnStatusesDto

    @Action('loadReturnStatusMapping')
    loadReturnStatusMapping!: () => Promise<void>

    @Action('saveReturnStatusMapping')
    saveReturnStatusMapping!: (mapping: ReturnStatusesDto) => Promise<void>

    private loadAnimate = this.STATE.DEFAULT

    async created (): Promise<void> {
        await this.handleCallback(async () => {
            await this.loadOrderStatusMapping()
            await this.loadReturnStatusMapping()
        })
    }

    async save (): Promise <void> {
        if (!this.validateReturnStatuses()) {
            return
        }

        this.loadAnimate = this.STATE.LOADING
        await (this.$refs.baseLayout as BaseLayout).handleWithAlerts(async () => {
            await this.saveOrderStatusMapping(this.orderStatuses)
            await this.saveReturnStatusMapping(this.returnOrderStatuses)
        }, this.$t('orderStatus.success') as unknown as string)

        this.loadAnimate = this.STATE.DEFAULT
    }

    private validateReturnStatuses (): boolean {
        const selected = (this.returnOrderStatuses?.statusesToMarket || [])
            .map((mapping: SettingsMapping) => mapping.codeSystem)
            .filter((codeSystem): codeSystem is string => Boolean(codeSystem))

        const unique = new Set(selected)
        const isValid = unique.size === selected.length
        if (!isValid) {
            (this.$refs.baseLayout as BaseLayout).showError(this.$t('returnStatusMapping.duplicateError') as unknown as string)
        }

        return isValid
    }
}
